import React, { useContext, useEffect, useState } from "react";
import {
  Toggle,
} from "@fluentui/react";
import themeContext from "../../../../../context/theme/ThemeContext";
import userContext from "../../../../../context/users/UserContext";
import loaderContext from "../../../../../context/loader/LoaderContext";
import { dataSwitchToggleAPI } from "../../../../../service/StudyListService";
import { useTranslation } from "react-i18next";
import CustomToolTipHost from "../../../../../components/CustomToolTipHost/CustomToolTipHost";

const DataToggleFilter = (props) => {
  const { themeName } = useContext(themeContext);
  const {isActiveData, setIsActiveData} = useContext(userContext);
  const { ref, setLoaderRunning } = useContext(loaderContext);
  const [t] = useTranslation();
  
  const [activeDataValue, setActiveDataValue] = useState(isActiveData);

  const onToggleChange = (event, checked) => {
    setActiveDataValue(checked);
  };

  useEffect(() => {
    handleToggleSwitch();
  }, [activeDataValue]);

  const handleToggleSwitch = async()=>{
    if(isActiveData != activeDataValue){
        const response = await dataSwitchToggleAPI(activeDataValue);
        if (response.status === 200 && response.data.result === "SUCCESS") {
            // OLD: localStorage.setItem('reloadPageDataSwitch', 'true');
            sessionStorage.setItem('reloadPageDataSwitch', 'true');
            setIsActiveData(activeDataValue);
            
        } else {
            
        }
    }
  }

  const tooltipContent = isActiveData 
        ? t("data-switch.active-cases-tooltip")
        : t("data-switch.archive-cases-tooltip");

  return (
    <>
    <div className="data-toggle-button">
      <CustomToolTipHost content={tooltipContent}>
        <Toggle
            checked={activeDataValue}
            onChange={onToggleChange}
            onText={t("data-switch.active-cases")}
            offText={t("data-switch.archive-cases")}
            styles={{
              root: {
                display: 'flex',
                alignItems: 'center',
                whiteSpace: 'nowrap'
              },
              label: {
                whiteSpace: 'nowrap'
              }
            }}
        />
      </CustomToolTipHost>
    </div>
    </>
  );
};

export default DataToggleFilter;